import { CSSProperties } from 'react';
import iconLogo from './icon-logo.svg';
import { CustomLogoProps } from './types';

const IconLogo = ({
  customIconLogo,
  style,
}: {
  customIconLogo: CustomLogoProps | undefined;
  style?: CSSProperties;
}) => {
  if (customIconLogo?.url) {
    return (
      <img
        style={style ?? { maxWidth: '40px' }}
        src={customIconLogo.url}
        alt=""
      />
    );
  }
  return (
    <img
      style={style ?? { maxHeight: '45px', maxWidth: '32px' }}
      src={iconLogo}
      alt="icon logo witboost"
    />
  );
};

export default IconLogo;
